import { createContext } from 'react';
import { QUERY_KEYS_PHONES, useChartsData } from '../../../../Common/hooks/useChartsData';
import { useSecurityFiltersContext } from '../../../Common/Filters/hooks/useSecurityFiltersContext';

export const RankingsChartsDataContext = createContext();

const RankingsChartsDataProvider = ({ children }) => {
    const { filters } = useSecurityFiltersContext();
    const currentYear = new Date().getFullYear();
    const filterParams = {
            year: filters.year?.value || '',
            month: filters.month?.value ? String(Number(filters.month?.value)) : "",
            location: filters.unidade.value,
            city: filters.cidade?.value,
    }

    const { data, isLoading, isError } = useChartsData(
        {
            key: QUERY_KEYS_PHONES.PHONES_RANKINGS_POLICE_STATION,
            url: 'governanceroom/securitydashboard/phones/rankings/byPoliceStation'
        },
        filterParams
    );

    const rankByDepartment = useChartsData(
        {
            key: QUERY_KEYS_PHONES.PHONES_RANKINGS_DEPARTMENT,
            url: 'governanceroom/securitydashboard/phones/rankings/byDepartment'
        },
        filterParams
    );

    const rankBySectional = useChartsData(
        {
            key: QUERY_KEYS_PHONES.PHONES_RANKINGS_SECTIONAL,
            url: 'governanceroom/securitydashboard/phones/rankings/bySectional'
        },
        filterParams
    );

    const rankByCity = useChartsData(
        {
            key: QUERY_KEYS_PHONES.PHONES_RANKINGS_CITY,
            url: 'governanceroom/securitydashboard/phones/rankings/byCity'
        },
        filterParams
    );

    const rankByNeighbourhood = useChartsData(
        {
            key: QUERY_KEYS_PHONES.PHONES_RANKINGS_NEIGHBOURHOOD,
            url: 'governanceroom/securitydashboard/phones/rankings/byNeighborhood'
        },
        filterParams
    );

    const rankBySubtypes = useChartsData(
        {
            key: QUERY_KEYS_PHONES.PHONES_RANKINGS_SUBTYPES,
            url: 'governanceroom/securitydashboard/phones/rankings/bySubtypes'
        },
        filterParams
    );

    const rankByTypes = useChartsData(
        {
            key: QUERY_KEYS_PHONES.PHONES_RANKINGS_TYPES,
            url: 'governanceroom/securitydashboard/phones/rankings/byTypes'
        },
        filterParams
    );

    const rankByBrands = useChartsData(
        {
            key: QUERY_KEYS_PHONES.PHONES_RANKINGS_BRANDS,
            url: 'governanceroom/securitydashboard/phones/rankings/byBrands'
        },
        filterParams
    );


    const chartData = {
        byPoliceStation: data || [],
        byDepartment: rankByDepartment.data || [],
        bySectional: rankBySectional.data || [],
        byCity: rankByCity.data || [],
        byNeighbourhood: rankByNeighbourhood.data || [],
        bySubtypes: rankBySubtypes.data || [],
        byTypes: rankByTypes.data || [],
        byBrands: rankByBrands.data || [],
    }

    return (
        <RankingsChartsDataContext.Provider
            value={{
                chartData,
                isLoading,
                isError,
                filters,
                data
            }}
        >
            {children}
        </RankingsChartsDataContext.Provider>
    );
};

export default RankingsChartsDataProvider;
